import React, { useState } from "react";
import {
    Container,
    Row,
    Col,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Card,
    CardBody
} from "reactstrap";
import classnames from "classnames";
import CommonHeader from "components/Headers/CommonHeader";
import RolesList from "./Roles";
import AdminsList from "./AdminManagement";

const AdminRolesTabs = () => {
    const [activeTab, setActiveTab] = useState("1");

    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    return (
        <>
            <CommonHeader />
            <Container className="mt--7" fluid>
                <Row>
                    <Col>
                        <Card className="shadow border-0" style={{ borderRadius: "16px", overflow: "hidden", background: "rgba(255, 255, 255, 0.95)", backdropFilter: "blur(10px)" }}>
                            <CardBody className="p-0">
                                <div className="nav-wrapper p-3">
                                    <Nav
                                        className="nav-pills nav-fill flex-column flex-md-row"
                                        id="tabs-icons-text"
                                        pills
                                        role="tablist"
                                    >
                                        <NavItem>
                                            <NavLink
                                                aria-selected={activeTab === "1"}
                                                className={classnames("mb-sm-3 mb-md-0", {
                                                    active: activeTab === "1"
                                                })}
                                                onClick={() => toggle("1")}
                                                href="#pablo"
                                                role="tab"
                                                style={{ borderRadius: "12px", fontWeight: 600 }}
                                            >
                                                <i className="ni ni-badge mr-2" />
                                                Role Management
                                            </NavLink>
                                        </NavItem>
                                        <NavItem>
                                            <NavLink
                                                aria-selected={activeTab === "2"}
                                                className={classnames("mb-sm-3 mb-md-0", {
                                                    active: activeTab === "2"
                                                })}
                                                onClick={() => toggle("2")}
                                                href="#pablo"
                                                role="tab"
                                                style={{ borderRadius: "12px", fontWeight: 600 }}
                                            >
                                                <i className="ni ni-single-02 mr-2" />
                                                Identity & Access Control
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                </div>
                                <TabContent activeTab={activeTab}>
                                    <TabPane tabId="1">
                                        <div className="p-0">
                                            <RolesList showHeader={false} isActive={activeTab === "1"} />
                                        </div>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <div className="p-0">
                                            <AdminsList showHeader={false} isActive={activeTab === "2"} />
                                        </div>
                                    </TabPane>
                                </TabContent>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default AdminRolesTabs;
